/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2019 - 2020 KlearNow Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearNow Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearNow Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearNow Corporation.
 */

import { saveTranactionNumberField } from '../api/setFormData'

const initialState = {
}

export default function TransactionNumberReducer(state = initialState, action) {
  switch (action.type) {
    case 'INITIALIZE_VALUES_TRANSACTION_NO': {
      return Object.assign({}, state, {'transactionNo': action.payload })
    }
    case 'UPDATE_TRANSACTION_NUMBER_FIELD': {
      return Object.assign({}, state, {'transactionNo': action.payload})
    }
    case 'SAVE_TRANSACTION_NUMBER_FIELD': {
      saveTranactionNumberField([action.field], action.payload, state.shipId)
      return state
    }
    default:
      return state
  }
}

